import React from "react";
import { Button, Modal } from "react-bootstrap";
import DefaultImg from "../images/no_profile.png";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../hooks/formatDateTime";

const { REACT_APP_BASE_URL, REACT_APP_IMAGE_URL } = process.env;

const SellerProfile = ({ show, handleClose, seller }) => {
    const { t, i18n } = useTranslation();
    return (
        <div>
            <Modal show={show} onHide={handleClose} centered size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("sellerProfile.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="col-12 mb-3">
                            <img
                                src={
                                    seller?.profile_pic ? `${REACT_APP_IMAGE_URL}${seller?.profile_pic}` : DefaultImg
                                }
                                style={{ width: 100, height: 100, borderRadius: 75, border: '2px solid #ddd' }}
                                className="object-fit-cover"
                            />
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.name")}:</strong> {seller?.user_name ?? t("common.naFallback")}
                            </div>
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.email")}:</strong> {seller?.email ?? t("common.naFallback")}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.storeName")}:</strong> {seller?.store_name && seller?.store_name !== "" ? seller?.store_name : t("common.naFallback")}
                            </div>
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.phoneNumber")}:</strong> {seller?.country_code} {seller?.phone_no}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.location")}:</strong> {seller?.location ?? t("common.naFallback")}
                            </div>
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.kvkNumber")}:</strong> {seller?.kyc_no ?? t("common.naFallback")}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.promoted")}:</strong>
                                {seller?.promoted ? t("common.yes") : t("common.no")}
                            </div>
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.emailVerified")}:</strong>
                                {seller?.email_verify ? t("common.yes") : t("common.no")}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.accountId")}:</strong> {seller?.account_id ?? t("common.naFallback")}
                            </div>
                            <div className="col-md-6">
                                <strong>{t("sellerProfile.createdAt")}:</strong>{" "}
                                {formatDateTime(seller?.created_at, i18n)}
                            </div>
                        </div>
                        {(seller?.promoted) &&
                            <div className="mb-3 d-flex flex-column">
                                <label className="form-label fw-600">{t("sellerProfile.companyLogo")}</label>
                                <img
                                    src={
                                        seller?.company_logo ? `${REACT_APP_IMAGE_URL}${seller?.company_logo}` : DefaultImg
                                    }
                                    style={{ width: 100, height: 100, borderRadius: 75, border: '2px solid #ddd' }}
                                    className="object-fit-cover "
                                />
                            </div>}
                        {(seller?.promoted) &&
                            <div className="mb-3">
                                <label className="form-label fw-600">{t("sellerProfile.bio")}</label>
                                <div className="password position-relative">
                                    <textarea
                                        name="notes"
                                        cols="4"
                                        rows="4"
                                        class="form-control b-0 text-area-height"
                                        placeholder={t("sellerProfile.bio")}
                                        style={{ height: '120px' }}
                                        value={seller?.bio}
                                    ></textarea>
                                </div>
                            </div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("common.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SellerProfile;
